<template>
  <div v-if="!loading" class="p-16 relative">
    <div class="max-w-5xl mx-auto space-y-16">
      <h3 class="text-indigo-500 capitalize">
        {{ order ? order.name : 'undefined' }}
      </h3>

      <OrderForm
        :action="doUpdateOrder"
        :order="order"
        :supplier-options="supplierOptions"
        :order-items="orderItems"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { clientAgenciesClient } from '@/api/clients';
import OrderForm from '@/components/Order/OrderForm.vue';

export default {
  components: {
    OrderForm,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    orderId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    supplierOptions: [],
  }),
  computed: {
    ...mapGetters('ui/orders', ['order', 'orderItems']),
  },
  created() {
    this.setup();
  },
  destroyed() {
    this.setCurrent(null);
  },
  methods: {
    ...mapActions('ui/orders', ['fetchOrder', 'updateOrder']),
    ...mapMutations('ui/orders', ['setCurrent']),
    async setup() {
      this.loading = true;

      const { orderId } = this;

      try {
        await this.fetchOrder({ orderId });
        const { data: { data = [] } = {} } = await clientAgenciesClient.list(this.accountId);

        this.supplierOptions = data.map((supplier) => ({
          label: supplier.account.name,
          value: supplier.account.id,
          accountRelationUuid: supplier.uuid,
        }));
      } catch (error) {
        // do sth
      }

      this.loading = false;
    },
    doUpdateOrder(...args) {
      const payload = args[0] || {};

      Object.assign(payload, { orderId: this.orderId });

      return this.updateOrder(payload)
        .then(() => Promise.resolve())
        .catch((error) => Promise.reject(error));
    },
  },
};
</script>
